import ApiClient from '@/api/client';
import { formatString } from '@/utils';

const DATASTORES_API_PATH = '/{0}/datastores/';

class DatastoreAPI extends ApiClient {

  constructor() {
    super();
  }

  /** GET */
  async getDatastoreList(datastoreType) {
    const route = `${formatString(DATASTORES_API_PATH, datastoreType)}databases/`;
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getTablesList(datastoreType,datastore,text=null) {
    let route = `${formatString(DATASTORES_API_PATH, datastoreType)}databases/${datastore}/?free=true`;
    if(text){
      route+=`&search=${text}`;
    }
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  /** CREATE */
  async createDatastore(datastoreType, data) {
    const route = `${formatString(DATASTORES_API_PATH, datastoreType.type)}${datastoreType.value}/`;
    const response = await this.post(route, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }
  async createDatastoreResource(id, datastoreType, data, async = true) {
    const route = `${formatString(DATASTORES_API_PATH, datastoreType.type)}${datastoreType.value}/${id}/?asynchrone=${async}`;
    const response = await this.patch(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  /** UPDATE */
  async updateDatastore(resourceId, datastoreType, data) {
    const route = `${formatString(DATASTORES_API_PATH, datastoreType.type)}${datastoreType.value}/${resourceId}/`;
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  /** SCENARII */
  async getDatastoreResourceScenarios(datastoreType, id) {
    const route = `${formatString(DATASTORES_API_PATH, datastoreType.type)}${datastoreType.value}/${id}/_scenarios/`;
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async runDatastoreResourceScenario(datastoreType, id, scenarioId, data) {
    const route =
      `${formatString(DATASTORES_API_PATH, datastoreType.type)}${datastoreType.value}/${id}/_scenarios/${scenarioId}/run/?asynchrone=true`;
    const response = await this.post(route, data);
    if (response.status === 202) {
      return response.data;
    }
    return false;
  }
}

const datastoreAPI = new DatastoreAPI();
export default datastoreAPI;